import TRUNCATE_UNITS from '@/utils/enum/TRUNCATE_UNITS';
import dateFormatter from '@/services/formatter_services/date-formatter';

const INVENTORY_WIDGETS = Object.freeze({
  INVENTORY_WIDGETS: [
    {
      id: 'stocktaking',
      path: 'stocktaking',
      getData: response => response.data.data?.map(item => item.data),
      headers: [
        {
          text: 'Common.status',
          value: 'status',
        },
        {
          text: 'Common.storageElement',
          value: 'storageElement',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 15
        },
        {
          text: 'Dashboard.widgets.stocktaking.headers.progress',
          value: 'progress'
        },
        {
          text: 'Common.createdAt',
          value: 'createdAt',
          presentWith: dateFormatter.formatDateToLocaleDateString
        },
        {
          text: 'Common.finishedAt',
          value: 'finishedAt',
          presentWith: dateFormatter.formatDateToLocaleDateString
        },
        {
          text: 'Common.deletedAt',
          value: 'finishedAt',
          presentWith: dateFormatter.formatDateToLocaleDateString
        },
        {
          text: 'Dashboard.widgets.stocktaking.headers.comment',
          value: 'comment',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20
        }
      ],
      type: 'TABLE',
      moduleId: 'stocktaking',
      withRouterActionLink: true
    },
  ]
});

export default INVENTORY_WIDGETS;
